import PropTypes from 'prop-types'
import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Button,
  ButtonGroup
} from 'react-bootstrap'
import KanBoPluginFormPicker from 'components/KanBoPlugin/FormPicker'

export class AddDocumentSourceForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired
  }

  renderNameField = (field) => {
    return (
      <FormGroup
        validationState={field.meta.touched && field.meta.error ? 'error' : null}>
        <ControlLabel><FormattedMessage id='NAME' /></ControlLabel>
        <FormControl
          {...field.input}
          name={null}
          type='text'
        />
        {field.meta.touched && field.meta.error && <HelpBlock>{field.meta.error}</HelpBlock>}
      </FormGroup>
    )
  }

  render () {
    const {
      onSubmit,
      handleSubmit,
      onCancelClick
    } = this.props

    return (
      <KanBoPluginFormPicker
        type='doc-template-source.form'
      >
        {({ render, submit, isLoaded, isSubmitting, plugin }) =>
          <form onSubmit={isLoaded ? handleSubmit((fields) => {
            if (plugin) {
              return new Promise((resolve, reject) => {
                submit()
                  .then(({ identifier, args }) => {
                    onSubmit({
                      ...fields,
                      pluginForm: {
                        identifier,
                        args
                      }
                    })
                      .then(() => resolve())
                      .catch(error => reject(error))
                  })
                  .catch(error => reject(error))
              })
            }
          }) : undefined}
          >
            <Field
              name='name'
              component={this.renderNameField}
            />
            {render()}
            <ButtonGroup>
              <Button type='submit' bsStyle='primary' disabled={isSubmitting || !plugin}><FormattedMessage id='ADD' /></Button>
              <Button onClick={onCancelClick}><FormattedMessage id='CANCEL' /></Button>
            </ButtonGroup>
          </form>
        }
      </KanBoPluginFormPicker>
    )
  }
}

export default reduxForm({
  form: 'addDocumentTemplateSourceForm'
})(AddDocumentSourceForm)
